import React, {useEffect, useMemo, useState} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {KTSVG} from '../../../../../_metronic/helpers'
import {PageTitle} from '../../../../../_metronic/layout/core'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import {getUserData} from '../../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import {GeneralDataOFLoginUser} from '../../../../Utils/Auth'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
import {
  DeletePaymentMethod,
  GetPaymentList,
} from '../../GatewayManagement/GatewayManagementSlice/GatewayManagementSlice'
import CreateNewPaymentGateway from './modal/CreateNewPaymentGateway'

const PaymentGatewayList = () => {
  const [gatewayPopup, setGatewayPopup] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [open, setOpen] = useState(false)
  const [deleteIds, setDeleteIds] = useState<any>()
  const [edit, setEdit] = useState<any>({})
  const paymentGatewayList = useSelector((state: any) => state?.paymentGateway?.paymentGateway)

  const Role = GeneralDataOFLoginUser()?.role

  const dispatch = useDispatch()

  const CreateNewPaymentGatewayPopup = useMemo(
    () => (
      <CreateNewPaymentGateway
        edit={edit}
        show={gatewayPopup}
        handleClose={() => setGatewayPopup(false)}
      />
    ),
    [gatewayPopup]
  )

  useEffect(() => {
    if (confirm == true) {
      dispatch(
        DeletePaymentMethod({
          id: deleteIds,
        })
      )
    }
  }, [confirm])

  useEffect(() => {
    dispatch(GetPaymentList())
  }, [])
  const handleDelete = (id: any) => {
    setOpen(true)
    setDeleteIds(id)
  }
  const handleEdit = (data: any) => {
    setEdit(data)
    setGatewayPopup(true)
  }

  const DeleteConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={open}
        handleClose={() => setOpen(false)}
        Message={'Are you sure, you want to delete this payment method?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )

  return (
    <>
      {CreateNewPaymentGatewayPopup}
      {DeleteConfirmation}
      <div className='card mb-0'>
        <div className='card-header card-header-stretch border-bottom-0'>
          <div className='card-title d-flex align-items-center'>
            <h3 className='fw-bolder m-0 text-gray-800'>Payment Gateway</h3>
          </div>
          <div className='card-toolbar m-0'>
            {/* Role Change Required+>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> */}
            {
              AuthenticateUser('create-payment-methods') && (
                <div className='d-flex gap-3 align-items-center'>
                  <button
                    onClick={() => {
                      setGatewayPopup(true)
                      setEdit({})
                    }}
                    className='btn btn-primary'
                  >
                    Create
                  </button>
                </div>
              )
              // : (
              //   <div className='d-flex gap-3 align-items-center'>
              //     <input
              //       type='text'
              //       name='value'
              //       className='form-control form-control-lg form-control-solid w-70px'
              //       placeholder='00'
              //     />
              //     <a href='#' className='btn btn-primary'>
              //       Update
              //     </a>
              //   </div>
              // )
            }
          </div>
        </div>
        <div className='card-body pt-2'>
          <div className='tab-content'>
            <div className='table-responsive'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bold text-muted text-uppercase'>
                    <th>Gateway Name</th>
                    <th>Account Name</th>
                    <th>Email</th>
                    <th>Staus</th>
                    <th className='text-end'>Action</th>
                  </tr>
                </thead>
                <tbody className='text-gray-600'>
                  {paymentGatewayList?.map((data: any, id: number) => (
                    <tr key={id}>
                      <td>
                        <span className='badge badge-light-info'>{data?.paymentGatewayName}</span>
                      </td>
                      <td>{data?.accountName}</td>
                      <td>{data?.email}</td>
                      <td>
                        <span
                          className={`${
                            data?.status == 'active'
                              ? 'badge badge-light-success '
                              : 'badge badge-light-danger'
                          }`}
                        >
                          {data?.status}
                        </span>
                      </td>
                      {/* <td>{data?.finalPrice}</td> */}
                      {Role == 'superAdmin' && (
                        <td className='text-end'>
                          {AuthenticateUser('edit-payment-methods') && (
                            <span
                              onClick={() => handleEdit(data)}
                              className='btn btn-bg-light btn-active-color-primary btn-sm'
                            >
                              Edit
                            </span>
                          )}
                          {AuthenticateUser('delete-payment-methods') && (
                            <span
                              onClick={() => handleDelete(data?._id)}
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-3'
                            >
                              <KTSVG
                                path='/media/icons/duotune/general/gen027.svg'
                                className='svg-icon-3'
                              />
                            </span>
                          )}
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PaymentGatewayList
